<template>
  <div style="position:relative;">
    <div
      class="scrollContainer"
      style="overflow: hidden; scroll-behavior: smooth; margin: 0px 3rem;"
    >
      <div class="d-flex">
        <img
            style="max-height: 200px; cursor: pointer;"
            v-for="(item, index) in items"
            class="book-thumbnail"
            :key="'coverspiner-' + item.id"
            :src="$store.state.user.siteData.location +
                'repository/books/' +
                item.id + '_1'"
            @click="$emit('selbook',index)"
          />
      </div>
    </div>
    <div
      class="d-flex align-items-center bg-white"
      style="position: absolute; top:0px; height: 100%; right: 0px; font-size: x-large;"
      @click="tooglePage(1)"
      v-if="pageRight"
    >
      <div class="p-2 slide-button">
        <b-icon icon="chevron-right" />
      </div>
    </div>
    <div
      class="d-flex align-items-center bg-white"
      style="position: absolute; top:0px; height: 100%; left: 0px; font-size: x-large;"
      @click="tooglePage(-1)"
      v-if="pageLeft"
    >
      <div class="p-2 slide-button">
        <b-icon icon="chevron-left" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: Array
  },
  data() {
    return {
      pageLeft: false,
      pageRight: true
    };
  },
  methods: {
    tooglePage: function(direction) {
      // console.log(this.$children[0].$el);
      
      this.$el.querySelector(".scrollContainer").scrollLeft +=
        direction * this.$el.querySelector('.book-thumbnail').getBoundingClientRect().width;

      const nextPos =
        this.$el.querySelector(".scrollContainer").scrollLeft +
        direction * this.$el.querySelector('.book-thumbnail').getBoundingClientRect().width;

      if (nextPos <= 0) {
        this.pageLeft = false;
      } else {
        this.pageLeft = true;
      }
      if (
        nextPos >=
        this.$el.querySelector(".scrollContainer").scrollWidth -
          this.$el.querySelector(".scrollContainer").offsetWidth
      ) {
        this.pageRight = false;
      } else {
        this.pageRight = true;
      }
    }
  }
};
</script>
